import React, { useState, useEffect } from "react";
import { AuthModal } from "../userLogin/AuthModal";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/slices/userSlice";
import URL from "../../config.json";

const CruzeLogo = require("../../assets/imgs/Cruze_White (4).webp");
const { WEBSITE_URL } = URL;

export const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const transparentPages = [""];
  const LoggedInState = useSelector((state) => state.user.loggedInState);
  const dispatch = useDispatch();
  const isConfirmBooked = useSelector(
    (state) => state.bookingConfirm.isConfirmBooked
  );
  const [logoutBlockedMsg, setLogoutBlockedMsg] = useState("");

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 580);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isTransparent =
    transparentPages.includes(location.pathname) && !isScrolled;

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleAuthModal = () => setIsAuthOpen(!isAuthOpen);
  // const handleLogout = () => {
  //   localStorage.removeItem("isLoggedIn");
  //   localStorage.removeItem("token");
  //   setIsLoggedIn(false);
  //   dispatch(logout());
  // };

  const handleLogout = () => {
    if (isConfirmBooked) {
      setLogoutBlockedMsg(
        "Searching for driver is ongoing. Please wait or cancel the search."
      );

      // Auto-hide the message after 4 seconds
      setTimeout(() => {
        setLogoutBlockedMsg("");
      }, 4000);

      return; // Prevent actual logout
    }

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    dispatch(logout());
  };

  const handleBlockedLinkClick = (e, href) => {
  if (isConfirmBooked) {
    e.preventDefault(); // Block default link navigation
    setLogoutBlockedMsg(
      "Searching for driver is ongoing. Please wait or cancel the search."
    );
    setTimeout(() => {
      setLogoutBlockedMsg("");
    }, 4000);
    return;
  }

  window.location.href = href; // Proceed with navigation manually
};


  return (
    <>
      <nav
        className={`fixed w-full top-0 left-0 z-50 transition-all duration-300 ${
          isTransparent ? "bg-transparent" : "bg-gray-900 shadow-lg"
        }`}
      >
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a
            href="#"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={CruzeLogo} className="h-8" alt="Cruze Logo" />
          </a>
          <button
            onClick={toggleMenu}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-white rounded-lg md:hidden hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 17 14"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={`${
              isOpen ? "block" : "hidden"
            } w-full md:block md:w-auto`}
          >
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-transparent md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0">
              {/* <Link
                to="/"
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Home
              </Link> */}
              <a
                href={`${WEBSITE_URL}`}
                  onClick={(e) => handleBlockedLinkClick(e, `${WEBSITE_URL}`)}
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Home
              </a>
              {/* <Link
                to="/tour-packages"
                className="block py-2 px-3 text-white hover:text-blue-400"
              > Tour Packages
              </Link> */}
              <a
                href={`${WEBSITE_URL}packages`}
                  onClick={(e) => handleBlockedLinkClick(e, `${WEBSITE_URL}`)}
                className="block py-2 px-2 text-white hover:text-blue-400"
              >
                Tour Packages
              </a>
              {/* <Link
                to="/services"
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Services
              </Link> */}
              <a
                href={`${WEBSITE_URL}#servicesSection`}
                  onClick={(e) => handleBlockedLinkClick(e, `${WEBSITE_URL}`)}
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Services
              </a>
              {/* <Link
                to="/contact"
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Contact
              </Link> */}
              <a
                href={`${WEBSITE_URL}#contactSection`}
                  onClick={(e) => handleBlockedLinkClick(e, `${WEBSITE_URL}`)}
                className="block py-2 px-3 text-white hover:text-blue-400"
              >
                Contact
              </a>

              {LoggedInState ? (
                // Account Dropdown Menu
                <li
                  className="relative"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                >
                  <button className="block py-2 px-3 text-white hover:text-blue-400">
                    Account ▼
                  </button>
                  {isDropdownOpen && (
                    <ul
                      onMouseLeave={() => setIsDropdownOpen(false)}
                      className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-lg"
                    >
                      {/* <Link
                        to="/profile"
                        className="block px-4 py-2 text-white hover:bg-gray-700"
                      >
                        My Profile
                      </Link> */}
                      <Link
                        to="/trips"
                        className="block px-4 py-2 text-white hover:bg-gray-700"
                      >
                        My Trips
                      </Link>
                      {/* <Link
                        to="/support"
                        className="block px-4 py-2 text-white hover:bg-gray-700"
                      >
                        Support
                      </Link> */}
                      <li>
                        <button
                          onClick={handleLogout}
                          className="w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                        >
                          Logout
                        </button>
                        {/* {logoutBlockedMsg && (
                          <p className="text-yellow-400 text-sm px-4 py-1">
                            {logoutBlockedMsg}
                          </p>
                        )} */}
                      </li>
                    </ul>
                  )}
                </li>
              ) : (
                <li>
                  <button
                    onClick={toggleAuthModal}
                    className="block py-2 px-3 text-white hover:text-blue-400"
                  >
                    Login / Sign Up
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
      {logoutBlockedMsg && (
        <div className="fixed top-16 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-black px-4 py-2 rounded shadow-lg z-[9999] text-center animate-pulse">
          {logoutBlockedMsg}
        </div>
      )}

      {/* Auth Modal Component */}
      <AuthModal
        isOpen={isAuthOpen}
        onClose={toggleAuthModal}
        onLoginSuccess={() => setIsLoggedIn(true)}
      />
    </>
  );
};
